import type {TypedSchema} from 'schemaDefinition/types';

/**
 * Presentation row for the update log table. Derived from {@link UpdateLog}:
 * the status enum is pre-localized into `status` in the scene, and `id` is
 * synthesized for the grid (neither is a backend field).
 */
export type UpdateLogRow = {
  id: string;
  /** Epoch milliseconds */
  created: number;
  ean: string;
  updatedBy: string;
  status?: string;
};

export const updateLogSchema: TypedSchema<UpdateLogRow> = {
  name: 'updateLog',
  parts: [
    {
      name: 'created',
      type: 'date',
    },
    {
      name: 'ean',
      type: 'text',
    },
    {
      name: 'status',
      type: 'text',
    },
  ],
};
